import React from 'react'
import { Switch, Route } from 'react-router-dom'
import slug from 'constants/slug'
import HookContainer from './hook'

export default props => (
  <Switch>
    <Route
      exact
      path={slug.hook}
      render={matchProps => <HookContainer {...matchProps} {...props} />}
    />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/containers/hook/index.js